import { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";
import { getISODateFormatted } from "lib/utils";

const GoogleAnalyticsBriefingsData = ({
  data,
}: {
  data: BriefingReportPageData;
}) => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          window.sifted_briefings_analytics_metadata = {
            "publishDateBriefing" : "${getISODateFormatted(data._firstPublishedAt)}",
          }
      `,
      }}
    />
  );
};
export default GoogleAnalyticsBriefingsData;
